import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import Dashboard from "./pages/Dashboard";
import Visualization from "./pages/Visualization";
import SimpleExample from "./pages/reactZoomPanPinchExample";
import { Repository } from "./types/repository";

const App = () => {
  const navigate = useNavigate();

  const handleNavigateToVisualization = (repository: Repository) => {
    navigate("/visualization", {
      state: { repository },
    });
  };

  return (
    <div>
      <Routes>
        <Route path="/" element={<Navigate replace to="/auth" />} />
        <Route path="/auth" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <Dashboard
              onNavigateToVisualization={handleNavigateToVisualization}
            />
          }
        />
        <Route path="/visualization" element={<Visualization />} />
        <Route path="/vis_test" element={<SimpleExample />} />
        <Route path="*" element={<Navigate replace to="/auth" />} />
      </Routes>
    </div>
  );
};

export default App;
